export function cn(...classes: (string | undefined | null | false)[]): string {
  return classes.filter(Boolean).join(' ');
}

export function formatCurrency(value: number): string {
  if (value >= 100000000) return `¥${(value / 100000000).toFixed(1)}亿`;
  if (value >= 10000) return `¥${(value / 10000).toFixed(1)}万`;
  return `¥${value.toLocaleString()}`;
}

export function formatNumber(value: number): string {
  if (value >= 10000) return `${(value / 10000).toFixed(1)}万`;
  return value.toLocaleString();
}

export function formatPercent(value: number, digits = 1): string {
  return `${value.toFixed(digits)}%`;
}

export function pad2(n: number | string): string {
  return String(n).padStart(2, '0');
}

export function todayStr(): string {
  return new Date().toISOString().split('T')[0];
}

export function lastNDays(n: number): string[] {
  const days: string[] = [];
  for (let i = n - 1; i >= 0; i--) {
    const d = new Date();
    d.setDate(d.getDate() - i);
    days.push(d.toISOString().split('T')[0]);
  }
  return days;
}

export function calcChange(current: number, last: number): number {
  if (last === 0) return current > 0 ? 100 : 0;
  return parseFloat((((current - last) / last) * 100).toFixed(1));
}
